import { isArray } from 'lodash';
import { ITag } from 'types/types';

export const serializeTag = (tag: ITag) => ({
  id: String(tag.id),
  title: tag.title,
  description: tag.description,
  backgroundColor: tag.background_color,
  textColor: tag.text_color,
  active: tag.show_in_selector
});

export const serializeTags = (tags: ITag[]) =>
  tags.map(tag => serializeTag(tag));

export const serializeTagsToMap = (tags: ITag[]) => {
  if (!isArray(tags) || tags.length < 1) return {};

  return tags.reduce((acc, at) => {
    const tag = serializeTag(at);
    return tag.id
      ? {
          [tag.id]: tag,
          ...acc,
        }
      : acc;
  }, {});
};
